class VariantForm {
  constructor(root) {
    this.root = root;
    this.productForm = document.querySelector('[is="product-form"]');
    this.productUpsell = document.querySelector("variant-upsell");
    // this.upsell = this.root.querySelector(
    //   'variant-upsell[data-product-name="Adaptador de transmissão"]'
    // );
    this.transmissionInput = this.root.querySelector('[name="Transmissão"]');
    this.formInitialized = false;

    if (!this.root || !this.productForm) {
      console.warn("VariantForm: missing required elements");
      return;
    }

    this.init();
  }
  initFormEvents() {
    if (this.formInitialized) return;

    const attachListeners = () => {
      if (this.formInitialized) return;

      const brandSelector =
        '.variant-selector__dropdown-select[data-element-id="dropdown-1"] .gpo-selected-values';

      const updateUpsellFromForm = () => {
        const checkedTransmission = this.root.querySelector(
          '[name="Transmissão"]:checked'
        );
        const brandNode = this.root.querySelector(
          '.variant-selector__dropdown-select[data-element-id="dropdown-1"] .gpo-selected-values'
        );

        const transmissionValue =
          checkedTransmission?.value?.toLowerCase() || "";
        const brandValue = brandNode?.innerText?.trim().toLowerCase() || "";

        // Build filters but remove empty ones
        const filters = {};
        if (transmissionValue) {
          filters["data-product-transmission"] = transmissionValue;
        }
        if (brandValue) {
          filters["data-product-brand"] = brandValue;
        }
        if (!this.productUpsell) return;
        this.productUpsell.dispatchEvent(
          new CustomEvent("variant-form:changed", {
            bubbles: true, // allow event to bubble up if needed
            detail: {
              transmission: transmissionValue,
              brand: brandValue,
              criteria: filters,
            },
          })
        );
      };

      // Single delegated listener for all changes in <variant-form>
      this.root.addEventListener("change", (e) => {
        updateUpsellFromForm();
      });

      // Also run once on init so the correct upsell shows immediately
      updateUpsellFromForm();

      this.formInitialized = true;
    };

    const observer = new MutationObserver(() => attachListeners());

    observer.observe(this.root, { childList: true, subtree: true });

    setTimeout(() => attachListeners(), 2000); // tenta de novo depois de 2s
  }

  init() {
    this.initFormEvents();
  }
}

// Usage (initialize once DOM is ready)
document.addEventListener("DOMContentLoaded", () => {
  const variantFormEl = document.querySelector("variant-form");
  if (variantFormEl) new VariantForm(variantFormEl);
});
